import { STATE_LAYER } from "../ds/IconButton";
import ViewTabs from "../ds/ViewTabs";

/*
  Figma "Creator tabs": the row over a space's Creator Rewards pages. Size S plain buttons in
  the app's soft colour, the open one on its deep fill. Phones keep the sideways chips,
  because these four labels don't fit a segmented control in Georgian.
*/
const CreatorTabs = ({ label, value, options, onChange, selectedClass }) => (
  <>
    <div className="min-[600px]:hidden">
      <ViewTabs label={label} value={value} onChange={onChange} options={options} selectedClass={selectedClass} />
    </div>
    <div role="tablist" aria-label={label} className="hidden flex-wrap gap-space-8 min-[600px]:flex">
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => !selected && onChange(option.value)}
            className={`relative inline-flex h-button-s items-center whitespace-nowrap rounded-radius-md px-space-12 text-caps-button-s uppercase text-app-creator-rewards-soft outline-none focus-visible:shadow-[0_0_0_2px_var(--color-focus-ring)] ${
              selected ? "bg-app-creator-rewards-deep" : STATE_LAYER
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  </>
);

export default CreatorTabs;
